import React from 'react';
import { QuickStartCatalogPage as PfQuickStartCatalogPage } from '@patternfly/quickstarts';

const QuickStartCatalog = ({ ...props }) => <PfQuickStartCatalogPage {...props} />;

export default QuickStartCatalog;
